import React from 'react';
import classnames from 'classnames';

export type ModalHeaderTitleProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalHeaderTitle = ({
  className,
  children,
  ...props
}: ModalHeaderTitleProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-modal__header-title');

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};
